export function mapByKey<T>(list: T[], key: keyof T) {
  const m = new Map();
  list.forEach(listItem => {
    m.set(listItem[key], listItem);
  });
  return m;
}
